import Vue from 'vue';
import axios from 'axios';
import { updateField } from 'vuex-map-fields';

export default {
    updateField,
    setUser(state, payload) {
        state.user = payload;
    },
    setInstance(state, payload) {
        state._widgetInstance = payload;
    },
    setSubscriptions(state, payload) {
        Vue.set(state, 'subscriptions', payload);
    },
    setPaymentAttempts(state, payload) {
        Vue.set(state, 'paymentAttempts', payload);
    },
    setDateOfBirth(state, payload) {
        state.user = { ...state.user, date_of_birth: payload };
    },
    setLanguage(state, payload) {
        state.user = { ...state.user, language: payload };
    },
    setTheme(state, payload) {
        state.user = { ...state.user, theme: payload };
    },
    token(state, payload) {
        // Store the token in the state and attach is as a header to all axios requests
        state.token = payload;
        axios.defaults.headers.common['X-ACCESS-TOKEN'] = state.token;
    },
    setHomeCountry(state, payload) {
        state.user = { ...state.user, home_country: payload };
    },
    setProfilePic(state, payload) {
        state.user = { ...state.user, profile_pic_url: payload };
    },
    first_name(state, payload) {
        state.user = { ...state.user, first_name: payload };
    },
    last_name(state, payload) {
        state.user = { ...state.user, last_name: payload };
    },
    home_state(state, payload) {
        state.user = { ...state.user, home_state: payload };
    },
    email(state, payload) {
        state.user = { ...state.user, email: payload };
    },
    nickname(state, payload) {
        state.user = { ...state.user, nickname: payload };
    },
    home_house_name(state, houseName) {
        state.user = { ...state.user, home_house_name: houseName };
    },
    home_house_number(state, houseNumber) {
        state.user = { ...state.user, home_house_number: houseNumber };
    },
    home_street(state, payload) {
        state.user = { ...state.user, home_street: payload };
    },
    home_city(state, payload) {
        state.user = { ...state.user, home_city: payload };
    },
    home_postcode(state, payload) {
        state.user = { ...state.user, home_postcode: payload };
    },
    setMobile(state, payload) {
        state.user = { ...state.user, mobile: payload };
    },
    clearHomeAddressFields(state) {
        state.user = {
            ...state.user,
            home_state: '',
            home_house_name: '',
            home_house_number: '',
            home_street: '',
            home_city: '',
            home_postcode: ''
        };
    },
    clearBillingAddressFields(state) {
        state.user = {
            ...state.user,
            billing_state: '',
            billing_house_name: '',
            billing_house_number: '',
            billing_street: '',
            billing_city: '',
            billing_postcode: ''
        };
    },
    use_home_as_billing(state, payload) {
        state.use_home_as_billing = payload;
    },
    setBillingFields(state, payload) {
        state.user = { ...state.user, ...payload };
    },
    setBillingCountry(state, payload) {
        state.user = { ...state.user, billing_country: payload };
    },
    billing_state(state, payload) {
        state.user = { ...state.user, billing_state: payload };
    },
    billing_house_name(state, houseName) {
        state.user = { ...state.user, billing_house_name: houseName };
    },
    billing_house_number(state, houseNumber) {
        state.user = { ...state.user, billing_house_number: houseNumber };
    },
    billing_street(state, payload) {
        state.user = { ...state.user, billing_street: payload };
    },
    billing_city(state, payload) {
        state.user = { ...state.user, billing_city: payload };
    },
    billing_postcode(state, payload) {
        state.user = { ...state.user, billing_postcode: payload };
    },
    setSelectedUpgrade(state, payload) {
        state.selectedUpgrade = { ...payload };
    },
    resetSelectedUpgrade(state) {
        state.selectedUpgrade = { id: null, pricingOption: null };
    },
    cancelSubscriptionChecked(state, payload) {
        state.cancelSubscriptionsCheckboxes[payload.subscriptionId] =
            payload.checked;
    },
    setSubscriptionUpgradeId(state, payload) {
        state.subscriptionUpgradeId = payload;
    },
    setPaymentStatus(state, payload) {
        state.paymentStatus = payload;
    },
    payment(state, payload) {
        state.payment = { ...state.payment, ...payload };
    }
};



// WEBPACK FOOTER //
// ./resources/assets/js/vuex/modules/Widget/mutations.js